import { clearQuerySuggest, registerQuerySuggest, selectQuerySuggestion, } from '../../../features/commerce/query-suggest/query-suggest-actions.js';
import { commerceQuerySuggestReducer as querySuggest } from './commerce-query-suggest-slice.js';
import { fetchQuerySuggestions } from './query-suggest-actions.js';
/**
 * Loads the query suggest reducer and returns the available query suggest action creators.
 *
 * @param engine - The headless engine.
 * @returns An object holding the query suggest action creators.
 *
 * @group Actions
 * @category QuerySuggest
 */
export function loadQuerySuggestActions(engine) {
    engine.addReducers({ querySuggest });
    return {
        clearQuerySuggest,
        fetchQuerySuggestions,
        registerQuerySuggest,
        selectQuerySuggestion,
    };
}
